/**
 * Per-row apply release outcome.
 */
export class ReleaseMeteringApplyItemDto {
  tenantId!: number;
  /** Set appliedHash = observedHash on success. */
  success!: boolean;
  appliedHash?: string | null;
}
